import * as React from 'react';

const FlightCardTag = (props) => {
    if (props.isCheapest) {
        return (
            <div className="flight-tag">{props.translator.trans('Cheapest')}</div>
        )
    }
    else if (props.isRecommended) {
        return (
            <div className="flight-tag">{props.translator.trans('Recommended')}</div>
        )
    }
    return null
};

export default FlightCardTag;



// WEBPACK FOOTER //
// ./src/components/flights/FlightCard/FlightCardTag.js